const Departments = (departments = [], action) => {
    switch (action.type) {
        case 'SET_DEPARTMENTS':
            return action.departments
        default:
            return departments
    }
}
export default Departments;